module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAgCAMAAAA2a+hwAAAAe1BMVEUAAAAAX+0Ad/cAafUKdfEAYOwAYe0AePMAePUAc/UAdPYAc/QAePYAd/YAdPQAd+0AdfUAcfMAcPMAePYAePQAYe0AevcAcfUAYO0AcPQAc/MAePYAdfMAdPYAX+0Ad/YAcfQAa/EAbvIAaPAAZvAAZO8Ac/QAdfUAYe4H6aj9AAAAHnRSTlMA8vISB7IqKRnm2sSykGAO+O7tvaamm5qQdGpXPzdJrrbLAAAAqElEQVQoz+3TtxLCMAwGYNlOr/SOpTQ77/+EXAoDRjlY2Pgnnb9FZ0kAgS/6vuvatmmqqqrrmigpYEogdO8imduEvj4peAnR0cTRWArtgYteatLxVWt4Q4himy8i3Ff2uohQWBkuIuSYlCwOzXhbPLB4KQFAoZzx+QlDvSEyxlpEZPC8dpDLr9Ed2Uf8d/sFCq14i1CCr/esqh1m3CHNOyTD8QQ5lFkID+SVJ+RhGhGQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/dataEffect/order_icon_select.png
// module id = 6W+Y
// module chunks = 1